export const enum CookieKeys {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  COOKIE_CONSENT = 'COOKIE_CONSENT'
}

/**
 * Per-category cookie consent. `functional` is always granted (essential for
 * the app to work); `analytics` and `advertising` are opt-in. Persisted as JSON
 * in the {@link CookieKeys.COOKIE_CONSENT} cookie.
 */
export interface CookieConsent {
  functional: true
  analytics: boolean
  advertising: boolean
}

export const COOKIE_CONSENT_MAX_AGE_DAYS = 365
